// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"129":"5dc6b2b3","312":"28aeab44","358":"7d9457e4","476":"684b0885","517":"e4775443","696":"596e0c8b","706":"360f6c15","789":"cacc5603","841":"0ecc99b5","878":"c1bfe901"}[chunkId] + ".chunk.js";
};